import './ThemeToggle.scss';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FormControl, MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { Map } from 'immutable';

import {
  THEME_PREFERENCE,
  getThemePreference,
  type DsThemePreference
} from 'src/module/authentication/theme.selector';
import { hasChemelexUiAlphaFeature, shouldUseChemelexUi } from 'src/module/authentication/chemelexUi.selector';
import { updateUser } from 'src/module/user/action';
import { useTranslation } from 'src/i18n';

const OPTIONS: { value: DsThemePreference; label: string }[] = [
  { value: 'system', label: 'profile.themeSystem' },
  { value: 'light', label: 'profile.themeLight' },
  { value: 'dark', label: 'profile.themeDark' },
];

/*
 * Hidden unless the user is on the new UI -- the theme only covers DS surfaces,
 * so on the legacy screens it would be a control that does nothing visible.
 * Also alpha-only: useDsTheme ignores the preference without the alpha feature.
 */
export default function ThemeToggle () {
  const dispatch = useDispatch();
  const isDsUi = useSelector(shouldUseChemelexUi);
  const canUseDarkMode = useSelector(hasChemelexUiAlphaFeature);
  const preference = useSelector(getThemePreference);
  const { t } = useTranslation();

  if (!isDsUi || !canUseDarkMode) {
    return null;
  }

  const handleChange = (event: SelectChangeEvent) => {
    dispatch(updateUser(null, Map({ [THEME_PREFERENCE]: event.target.value })));
  };

  return (
    <div className='theme-toggle'>
      <h4>{t('profile.theme')}</h4>
      <FormControl size='small'>
        <Select
          value={preference}
          onChange={handleChange}
          inputProps={{ 'aria-label': t('profile.theme') }}
          sx={{ minWidth: 120 }}
        >
          {OPTIONS.map(({ value, label }) => (
            <MenuItem key={value} value={value}>{t(label)}</MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}
